module.exports = __webpack_public_path__ + "static/media/Trio Evocacion 6.86cf9f3d.jpg";